import React from "react";
import { Link } from "react-router-dom";
import styles from "../../styles/landing.module.css";

const HeroSection = () => {
  return (
    <section className={styles.heroSection}>
      <div className={styles.heroContentCentered}>
        <div className={styles.mainSlogan}>
          <h1><span className={styles.glowingText}>Optimize</span> your learning with the science of <span className={styles.highlightedText}>memorization</span></h1>
        </div>
        
        <div className={styles.subSlogans}>
          <div className={styles.subSloganItem}>
            <h3>Visualize your memory</h3>
            <p>See how your knowledge retention evolves over time</p>
          </div>
          
          <div className={styles.subSloganItem}>
            <h3>Learn smarter, not harder</h3>
            <p>Study at the perfect moment for maximum retention</p>
          </div>
          
          <div className={styles.subSloganItem}>
            <h3>Never forget again</h3>
            <p>Turn short-term information into permanent knowledge</p>
          </div>
        </div>
        
        <div className={styles.heroDescription}>
          <p>
            Schedule your revisions at the optimal time based on scientific algorithms.
            Retain knowledge forever with less effort.
          </p>
        </div>
        
        <div className={styles.heroButtons}>
          <Link to="/register" className={styles.ctaButton}>
            Start for free
          </Link>
          <a href="#scientific-back" className={styles.secondaryButton}>
            Learn more
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 